import * as constAction from 'root/actionConstants';

export const clear = (value) => ({
  type: constAction.TRAYECTOS_CLEAR,
  payload: value,
});

export const setState = (payload) => ({
  type: constAction.TRAYECTOS_SET_STATE,
  payload: payload,
});

export const delState = (trayectoId) => ({
  type: constAction.TRAYECTOS_DELETE_STATE,
  payload: trayectoId,
});

export const get = () => ({
  type: constAction.TRAYECTOS_GET,
  epic: {
    url: 'trayectos/getAll',
    method: 'GET',
  },
});

export const getFull = (trayectoId) => ({
  type: constAction.TRAYECTOS_GETFULL,
  payload: { trayectoId },
  epic: {
    url: 'trayectos/getFull',
    method: 'GET',
  },
});

export const set = (payload, id) => ({
  type: constAction.TRAYECTOS_SET,
  payload,
  epic: {
    url: id ? `trayectos/${id}` : 'trayectos',
    method: id ? 'PATCH' : 'POST',
  },
});

export const preview = (salida, destino, paradas, autoOrdenarParadas) => ({
  type: constAction.TRAYECTOS_PREVIEW,
  payload: { salida, destino, paradas, autoOrdenarParadas },
  epic: {
    url: 'trayectos/previewTrayecto',
    method: 'POST',
  },
});

export const delete_ = (trayectoId) => ({
  type: constAction.TRAYECTOS_DELETE,
  payload: { trayectoId },
  epic: {
    url: 'trayectos/eliminar',
    method: 'GET',
  },
});

export const buscarParada = (trayectoId, query, reducerName) => ({
  type: constAction.TRAYECTOS_FIND_PARADA,
  parameters: { reducerName },
  payload: { trayectoId, query },
  epic: {
    url: 'trayectos/buscarParadas',
    method: 'GET',
  },
});

export const getParadas = (trayectoId, page = 0, orderAsc = false, reducerName = false) => ({
  type: constAction.TRAYECTOS_GET_PARADAS,
  parameters: { reducerName },
  payload: { trayectoId, page, orderAsc },
  epic: {
    url: 'trayectos/getParadas',
    method: 'GET',
  },
});

export const getParadasUser = (trayectoId, id, tipo, reducerName) => ({
  type: constAction.TRAYECTOS_GET_PARADAS_USER,
  parameters: { reducerName },
  payload: { trayectoId, [tipo]: id },
  epic: {
    url: 'trayectos/getParadasPersonalizadasUsuarios',
    method: 'GET',
  },
});

export const getTasks = (trayectoId, task) => ({
  type: constAction.TRAYECTOS_GET_TASKS,
  payload: { trayectoId, task },
  epic: {
    url: 'dispositivoPlannedTasks/getTasks',
    method: 'GET',
  },
});

export const taskPhoto = (payload) => ({
  type: constAction.TRAYECTOS_PHOTOS_TASK,
  payload,
  epic: {
    url: 'dispositivoPlannedTasks/photos',
    method: 'POST',
  },
});



// WEBPACK FOOTER //
// src/modules/trayectos/action.js